export default "__VITE_ASSET__D_j0nI$W__"